import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jconst(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

<Sides/>
<Helmet>
 
  <title>Master the Art of Java Constructors: A Beginner's Tutorial by CodeExampler</title>
<meta name="description" content="Enhance your Java programming skills with CodeExampler's comprehensive tutorial on Java constructors. Learn about constructor overloading, chaining, inheritance, and more with simple examples. Start your journey towards mastering Java today!" />
<meta name="keywords" content="Java constructors, constructor overloading,constructor in java in hindi, constructor chaining in java, constructor inheritance,java object-oriented programming, CodeExampler." />
<link rel="canonical" href="https://www.codeexampler.com/java-constructor"/>
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Using Constructor in Java</h1>
    <div className="first">
        <a href="/java-object-initialize">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-why we Use Constructor in Java?
</h2>

<p className="mt-4 para"><span className="bold">Ans-</span> Constructor in java because The main use of constructor initializes an object 
constructor in java  has no return type and no use void because of unexpressed return type value of a class<br/>
The Constructor executes automatically when we create an object.
</p>




<h2 className="headings">Q-constructor in java example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>




          <span className="qwerty-5">class</span>
            <span className="qwerty-4"> Construct</span>
            {"\n"}        
             
      
      
      
      
            <span className="qwerty-3">&#123; </span>
            {"\n"} 
            <span className="qwerty-10">&nbsp;int </span>
            <span className="qwerty-4">a;</span>
            {"\n"} 
            <span className="qwerty-4"> Construct</span>
            <span className="qwerty-1">() </span>
            {"\n"} 
            <span className="qwerty-3">&nbsp;&#123; </span>
            {"\n"} 
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;a</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-1">40;</span>

            {"\n"} 
            <span className="qwerty-3">&nbsp;&#125; </span>
             
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> mainClass</span>
            {"\n"}
           
                            
             
              <span className="qwerty-7">&nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
            {"\n"} 
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;Construct</span>
            <span className="qwerty-3"> c1</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-5">new </span>
            <span className="qwerty-4">Construct</span>
            <span className="qwerty-1">();</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;Construct</span>
            <span className="qwerty-3"> c2</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-5">new </span>
            <span className="qwerty-4">Construct</span>
            <span className="qwerty-1">();</span>
            {"\n"} 
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
              <span className="qwerty-3">c1</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-3">""</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-3">c2</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-1">);</span>
            {"\n"}
           
      
      
      
      
            <span className="qwerty-3">&nbsp;&nbsp;&#125; </span>
            {"\n"} 
            <span className="qwerty-3">&#125; </span>
              {"\n"}
      
      
      
      
      
         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp;40 40</span>
            {"\n"}              
              </code>{"   "}
              </pre>
        </div>
      </div>


<h2 className="mt-4 mh2">There are 3 types of constructor in java:
</h2>
<p className="mt-4 para">1, Default constructor in java<br/>
2, User-defined constructor(no-argument constructor in java)<br/>
3, Parameterized constructor <br/></p>

<h2 className="mt-4 mh2">1, Default constructor in java:</h2>
<p className="mt-4 para">Default constructor in java The compiler creates automatically a constructor if you do not create a constructor and this is no-argument constructor this is known as <span className="bold"> default constructor</span>
</p>


<h2 className="headings">Q-Default Constructor in java example?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> def</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-8">&nbsp;&nbsp;def</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}
              <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-10">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">"Hello default constructor in CodeExampler"</span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}
                              
               
                <span className="qwerty-7">&nbsp; &nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"} 
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;def</span>
              <span className="qwerty-3"> d</span>
              <span className="qwerty-8"> = </span>
              <span className="qwerty-5">new </span>
              <span className="qwerty-4">def</span>
              <span className="qwerty-1">();</span>
              {"\n"} 
             
        
        
        
        
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"} 
              <span className="qwerty-3">&#125; </span>
                {"\n"}
        
        
            </code>
          </pre>        
        </div>
        
        <div>
          <h3 className="headings">Output</h3>
          <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
            <pre style={{ maxHeight: '500vh' }}>
              <code className="python hljs">
              {"\n"}
              <span className="qwerty-9">&nbsp;Hello default constructor in CodeExampler</span>
              {"\n"}              
                </code>{"   "}
                </pre>
          </div>
        </div>
        

<h2 className="mt-4 mh2">Important Point in a constructor in Java </h2>
<p className="mt-4 para">constructor create automatically by the compiler if you do not create constructor name of the default
</p>
<h2 className="mt-4 mh2">2, No Argument constructor in java:
</h2>

<p className="mt-4 para">no argument constructor in java the user create constructor means this constructor create my own or user and this is also Known as <span className="bold"> no-argument constructor</span></p>


<h2 className="headings">Q-No Argument constructor in java example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> noarg</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-8">&nbsp;&nbsp;noarg</span>
            <span className="qwerty-1">()</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">"This is noArgument constructor in code Exampler"</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}{"\n"}
                            
             
              <span className="qwerty-7">&nbsp; &nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"} 
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;noarg</span>
            <span className="qwerty-3"> na</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-5">new </span>
            <span className="qwerty-4">noarg</span>
            <span className="qwerty-1">();</span>
            {"\n"} 
           
      
      
      
      
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"} 
            <span className="qwerty-3">&#125; </span>
              {"\n"}
      
      
      
      
      
         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp;This is no argument constructor in code Exampler</span>
            {"\n"}              
              </code>{"   "}
              </pre>
        </div>
      </div>


<h2 className="mt-4 mh2">3, Parameterized constructor:</h2>
<p className="mt-4 para"> Parameterized constructor in java user create constructor means this constructor create my own or use and also pass parametrize
</p>


<h2 className="headings">Q-Parameterized constructor in Java Example?</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-5">class</span>
            <span className="qwerty-4"> para</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;int</span>
            <span className="qwerty-4"> no;</span>
            {"\n"}
            <span className="qwerty-8">&nbsp;&nbsp;para</span>
            <span className="qwerty-1">(</span>
              <span className="qwerty-10">int </span>
              <span className="qwerty-4">i</span>
              <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;this</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-4">no</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-4">i;</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}{"\n"}
                            
             
              <span className="qwerty-7">&nbsp; &nbsp;public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-3">void </span>
            <span className="qwerty-8">main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-10">String</span>
            <span className="qwerty-1">[] </span>
            <span className="qwerty-9">args</span>
            <span className="qwerty-1">) </span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"} 
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;para</span>
            <span className="qwerty-3"> pa</span>
            <span className="qwerty-8"> = </span>
            <span className="qwerty-5">new </span>
            <span className="qwerty-4">para</span>
            <span className="qwerty-1">(10);</span>
            {"\n"} 
            <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">"Number is:"</span>
            <span className="qwerty-8">+</span>
            <span className="qwerty-3"> pa</span>
            <span className="qwerty-8">.</span>
            <span className="qwerty-4">no</span>
            <span className="qwerty-1">);</span>
            {"\n"}
           
      
      
      
      
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"} 
            <span className="qwerty-3">&#125; </span>
              {"\n"}
      
      
      
      
      
         
          </code>
        </pre>        
      </div>
      
      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
            <span className="qwerty-9">&nbsp;Number is:10</span>
            {"\n"}              
              </code>{"   "}
              </pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/java-object-initialize">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jconst;